import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../redux/slices/snackbar";
import { useDispatch } from "react-redux";

import {
  Alert as MuiAlert,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardContent,
  CircularProgress,
  TextField as MuiTextField,
  Grid,
  CardHeader,
  Typography,
  MenuItem,
} from "@mui/material";
import { spacing } from "@mui/system";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";

import SaveCancel from "../../../components/SaveCancel";
import usePppSecret from "../../../hooks/usePppSecret";
import PppSecretFields from "./components/PppSecretFields";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Card = styled(MuiCard)(spacing);

const Alert = styled(MuiAlert)(spacing);

const validationSchema = Yup.object().shape({
  status: Yup.string().required("Required"),
  interimUpdate: Yup.string().required("Required"),
  nas: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required(),
});

function EditPppSecret() {
  const { getPppSecret, pppSecret, updatePppSecret, isSubmitting } = usePppSecret();
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (Object.keys(pppSecret).length !== 0) {
      console.log(pppSecret.status, "pppSecret.status");
      console.log(pppSecret.nas, "naassnass1111111");
      const initialValues = {
        pppSecretId: pppSecret.pppSecretId,
        nas: {
          value: pppSecret.nas.nasId,
          label: pppSecret.nas.nasName,
        },
        useRadius: pppSecret.useRadius,
        useAccounting: pppSecret.useAccounting,
        interimUpdate: pppSecret.interimUpdate,
        status: pppSecret.status,
      };
      reset(initialValues);
    }
  }, [pppSecret]);

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });

  const [status, setStatus] = useState({
    sent: false,
  });

  const [errorSubmit, setErrorSubmit] = useState({
    submit: "",
  });

  const { state } = useLocation();
  console.log(state, "location");
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = methods;

  const onSubmit = async (data) => {
    try {
      data["nas"] = {
        nasId: data.nas.value,
        nasName: data.nas.label,
      };
      await updatePppSecret(data);
      navigate("/mikrotik-mgnt/ppp-secret/list");
      reset();
      dispatch(showSuccessSnackbar("PppSecret update Successfully!"));
    } catch (err) {
      dispatch(showErrorSnackbar("Failed to update PppSecret"));
    }
  };

  const cancelBtn = () => {
    navigate("mikrotik-mgnt/ppp-secret/list");
  };

  const breadCrump = () => {
    return (
      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Typography>Mikrotik Access Mgnt</Typography>
        <Typography>PppSecret</Typography>
        <Typography>Edit</Typography>
      </Breadcrumbs>
    );
  };

  const fetchData = async () => {
    await getPppSecret(state.id);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <Card mb={6}>
          <CardHeader title={t("edit_pppSecret")} subheader={breadCrump()} />
          <CardContent>
            {status && status.sent && (
              <Alert severity="success" my={3}>
                PppSecret updated successfully!
              </Alert>
            )}

            {isSubmitting ? (
              <Box display="flex" justifyContent="center" my={6}>
                <CircularProgress />
              </Box>
            ) : (
              <form onSubmit={handleSubmit(onSubmit)}>
                <PppSecretFields fields={validationSchema.fields} />
                <SaveCancel cancelBtn={cancelBtn} resetForm={reset} />
              </form>
            )}
          </CardContent>
        </Card>
      </FormProvider>
    </React.Fragment>
  );
}

export default EditPppSecret;
